// Bileli · shared/i18n — the Kyrgyz dictionary, keyed by the RUSSIAN source string (gettext-style; see
// index.ts). Split by app area purely to keep files reviewable; merged flat here. A missing entry is not
// an error — t() falls back to the Russian key.

import { KY_COMMON } from './ky.common';
import { KY_LEARN } from './ky.learn';
import { KY_TEACH } from './ky.teach';

export const KY: Record<string, string> = {
  ...KY_COMMON,
  ...KY_LEARN,
  ...KY_TEACH,
};
